module.exports = __webpack_public_path__ + "static/gate3-9aa678088b5ad0a853abce71c6b6ff29.jpg";